import { VaultAccountType } from '@/types/myVaultTypes';
import { CardActions, CardInfo, CardMain, CardWrapper, BankName } from './styles';
import { Box } from '@/components/Box/Box';
import { COLORS } from '@/styles/colors';
import { Typography } from '@/components/Typography/Typography';
import { VaultAccountStatus } from '../VaultAccountStatus';
import { InlineAction } from '../../styles';
import { formatDate, FULL_MONTH_DATE_FORMAT } from '@/helpers/dateHelpers/dateHelpers';
import { ButtonNew } from '@/components-new/ButtonNew/ButtonNew';
import { LuUpload } from 'react-icons/lu';
import { Mono } from '@/styles/common';

type VaultCardType = {
  account: VaultAccountType;
  onClose: () => void;
  onShare: () => void;
  onView: () => void;
  onAddRail: (code: string) => void;
  onConfirm: () => void;
};

export const VaultCard = ({ account, onClose, onShare, onView, onAddRail, onConfirm }: VaultCardType) => {
  const {
    nickname,
    bank_name,
    status,
    country,
    masked_number,
    rail_labels,
    record_hash_short,
    missing_rails,
    date_modified,
    initials,
  } = account;
  const date = formatDate(date_modified, FULL_MONTH_DATE_FORMAT);

  const onCloseHandler = (event) => {
    event.stopPropagation();
    onClose();
  };

  const onShareHandler = (event) => {
    event.stopPropagation();
    onShare();
  };

  const onAddRailHandler = (event, railCode) => {
    event.stopPropagation();
    onAddRail(railCode);
  };

  const onConfirmHandler = (event) => {
    event.stopPropagation();
    onConfirm();
  };

  return (
    <CardWrapper onClick={onView}>
      <CardInfo>
        <BankName title={bank_name}>{initials}</BankName>

        <Box display='flex' flexDirection='column' gap='4px' alignItems='flex-start'>
          <Box display='flex' justifyContent='center' gap='12px' alignItems='center'>
            <Typography fontWeight='semibold'>{nickname}</Typography>
            <VaultAccountStatus status={status}></VaultAccountStatus>
          </Box>
          <Typography variant='bodySmall'>
            {bank_name} · {country} · <Mono>{masked_number}</Mono>
          </Typography>
          <Typography variant='bodySmall'>
            Record <Mono>{record_hash_short || '-'}</Mono> · saved {date}
          </Typography>
        </Box>
      </CardInfo>

      <CardMain>
        <Box display='flex' gap={'8px'}>
          {rail_labels.map((rail) => (
            <Box key={rail.code} background={COLORS.mint[200]} padding={'4px 6px'} borderRadius={'4px'}>
              <Typography variant='bodySmall2' color={COLORS.green[600]} fontWeight='semibold'>
                {rail.label}
              </Typography>
            </Box>
          ))}
        </Box>

        <Box
          display='flex'
          flexWrap='wrap'
          gap='12px'
          marginTop='12px'
          flexDirection='column'
          alignItems={'flex-start'}
        >
          {missing_rails.map((rail) => (
            <InlineAction key={rail.code} onClick={(event) => onAddRailHandler(event, rail.code)}>
              + Add {rail.label} instructions
            </InlineAction>
          ))}
        </Box>
      </CardMain>

      <CardActions>
        <Box display='flex' gap='20px'>
          <ButtonNew onClick={onShareHandler}>
            <LuUpload style={{ marginRight: '8px' }} /> Share
          </ButtonNew>
          {account.status === 'pending_confirmation' && (
            <ButtonNew size='medium' variant='secondary' onClick={onConfirmHandler}>
              Confirm
            </ButtonNew>
          )}
        </Box>
        <InlineAction $danger onClick={onCloseHandler}>
          Close account
        </InlineAction>
      </CardActions>
    </CardWrapper>
  );
};
